<div [ngClass]="{'notification': true, 'notification-success': success, 'notification-warning': warning, 'notification-error': error}" [hidden]="!message">
	<span>
		{{message}}
	</span>
</div>
